import { ContactPhone, PHONE_CONFIGS } from './model/phone-config';

export function buildOtpPhone(value: ContactPhone): string {
  return `${PHONE_CONFIGS[value.country].code}${value.areaCode}${value.phone}`;
}

export function buildLegacyPhone(value: ContactPhone): string | null {
  return value.country === 'AR' ? `0${value.areaCode} 15${value.phone}` : null;
}

export function isNationalPhoneValid(value: ContactPhone): boolean {
  const nationalPhone = value.areaCode + value.phone;
  return PHONE_CONFIGS[value.country].regex.test(nationalPhone) &&
    (value.country !== 'AR' || nationalPhone.length === 10);
}
